import AppService from '../app.service';
const appService = new AppService();

export const VERSION_POLL_INTERVAL = 5 * 60 * 1000;
export const VERSION_STORAGE_KEY = 'version';

export function checkVersion(reload = force => window.location.reload(force)) {
  appService
    .validateVersion()
    .then(res => {
      const version = res?.results?.[0]?.val_version;
      if (res?.type !== 'success' || !version) return;
      localStorage.setItem(VERSION_STORAGE_KEY, version);
    })
    .catch(error => {
      console.warn('Version check failed, backend may be unavailable:', error);
    });
}

export function startVersionPolling(
  intervalMs = VERSION_POLL_INTERVAL,
  { immediate = true } = {},
) {
  if (immediate) checkVersion();
  const timer = setInterval(() => checkVersion(), intervalMs);
  return () => clearInterval(timer);
}
